<div
  (click)="addnewLink()" class="h-100 uploadHover">
  <div class="w-100 h-100 d-flex align-items-center justify-content-center flex-column">
    <span class="bigRoundButton mb-3">
      <sb-icon icon="link"></sb-icon>
    </span>
    <p class="text-center m-0" style="width: 175px;">{{'lang.globals.createLink' | translate}}</p>
  </div>
</div>
